import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { SkillsSettings } from './settings-skills.component';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';

export function provideSettingsElementSkills(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'skills',
        name: 'Skills',
        icon: 'tf-settings-skills',
        component: SkillsSettings,
        order: 5,
        translateName: 'SETTINGS_SKILLS.TITLE',
        resource_key: 'skills',
        required_action: 'read',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
